import { Typography, TextField } from "@mui/material";
import { useLiteRaveCreateContext } from "../LiteRaveCreateContext";

export const RecipientSection = () => {
  const {
    recipientName,
    setRecipientName,
    recipientEmail,
    setRecipientEmail,
    loading,
  } = useLiteRaveCreateContext();

  return (
    <>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Recipient Information (Optional)
      </Typography>

      <TextField
        fullWidth
        label="Recipient Name"
        value={recipientName}
        onChange={(e) => setRecipientName(e.target.value)}
        sx={{ mb: 3 }}
        disabled={loading}
      />

      <TextField
        fullWidth
        label="Recipient Email"
        type="email"
        value={recipientEmail}
        onChange={(e) => setRecipientEmail(e.target.value)}
        sx={{ mb: 3 }}
        disabled={loading}
      />
    </>
  );
};
